import React from 'react'

import { CONTENT_PASTE_ICON } from '../../constants/urls'

const TitleContainer: React.FC = () => (
  <div className='flex flex-col gap-4 justify-center items-center mt-4'>
    <img
      className="md:w-[35px] md:h-[35px] md:mr-[2vh] md:block portrait:hidden"
      alt="tracking-icon"
      src={`${CONTENT_PASTE_ICON}`}
    />
    <div>
      <p className="flex mb-[10px] md:text-xl portrait:text-2xl font-['Onest'] font-semibold text-black">
        Rastrea tu pedido
      </p>
    </div>
  </div>
)

export default TitleContainer
